import React from 'react';
import PropTypes from 'prop-types';

import styles from './nextAvailable.scss';
import useCloseAnimation from '../../../components/hooks/useCloseAnimation';

const NextAvailableSidePanel = (props) => {
    const {
        className,
        allowCloseOnClickOutside,
        closeSideBar,
        children,
        fullScreen,
        isVisible,
        onClose,
    } = props;

    const { isClosed, isClosing } = useCloseAnimation({ isVisible, onClose });

    const handleClose = () => {
        closeSideBar();
    };
    const onClickOutsideSideBar = () => {
        if (allowCloseOnClickOutside) {
            handleClose();
        }
    };

    if (isClosed) {
        return null;
    }

    return (
        <div
            className={`${styles.nextAvailableSidePanel} ${className}`}
        >
            <div
                className="flex-1"
                onClick={onClickOutsideSideBar}
            />
            <div className={`${styles.sidebar} ${fullScreen ? styles.fullScreen : ''} ${isClosing ? styles.closing : styles.opening}`}>
                {children}
            </div>
        </div>
    );
};

NextAvailableSidePanel.propTypes = {
    className: PropTypes.string,
    allowCloseOnClickOutside: PropTypes.bool,
    closeSideBar: PropTypes.func,
    children: PropTypes.node.isRequired,
    fullScreen: PropTypes.bool,
    isVisible: PropTypes.bool,
    onClose: PropTypes.func,
};

NextAvailableSidePanel.defaultProps = {
    className: '',
    allowCloseOnClickOutside: false,
    closeSideBar: () => { },
    fullScreen: false,
    isVisible: true,
    onClose: null,
};

export default NextAvailableSidePanel;
